import { render } from "./realizarReserva.vue?vue&type=template&id=b8e4814c&scoped=true"
import script from "./realizarReserva.vue?vue&type=script&lang=js"
export * from "./realizarReserva.vue?vue&type=script&lang=js"

import "./realizarReserva.vue?vue&type=style&index=0&id=b8e4814c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8e4814c"]])

export default __exports__